const WalletsSkeleton = () => (
  <div className="flex flex-wrap justify-center align-center gap-3">
    <div className="animate-pulse w-[250px]">
      <div className="h-[100px] bg-gray-300 w-full" />
    </div>
    <div className="animate-pulse w-[250px]">
      <div className="h-[100px] bg-gray-300 w-full" />
    </div>
    <div className="animate-pulse w-[250px]">
      <div className="h-[100px] bg-gray-300 w-full" />
    </div>
  </div>
);

export default WalletsSkeleton;
